import { GrMoney } from 'react-icons/gr';
import './WishRequest.css';
import { PRIMARY } from '../../utils/colors';
import { BsCalendar4Week } from 'react-icons/bs';
import { dateDisplay } from '../../utils/helpers';
import { Button, Col, Row } from 'reactstrap';
import { API_URL } from '../../utils/constants';

function WishRequestCard({wish, refresh}) {
  const destroy = () => {
    fetch(API_URL+'/user/wish-requests/destroy/'+wish.id, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => response.json())
    .then(data => {
      if(data.success) {
        refresh();
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

  return(
    <div className="wish-card p-4 mb-4">
      <Row>
        <Col xs="9">    
          <h4 className="text-primary mb-4">{wish.title}</h4>
        </Col>
        <Col xs="3" className="text-end">
          <Button outline color='danger' size='sm' onClick={() => destroy()}>
            حذف
          </Button>
        </Col>
      </Row>

      <div className='mb-4'>
        <GrMoney color={PRIMARY} className='me-2' />
        { wish?.price_from } - { wish?.price_to } د.ك
      </div>

      <BsCalendar4Week color={PRIMARY} className='me-2' />
      <span>تاريخ الإنتهاء: { dateDisplay(wish.created_at) }</span>
    </div>
  );
}

export default WishRequestCard;